<template>
    <div class='main'>
        <div class='content'>
            <div class='content-header'>
                <h5>保護者一覧</h5>
            </div>
            <div class='buttons'>
                <button class='button' @click='buyHistry'>購入履歴</button>
                <button class='button is-danger' @click='deleteParent'>一括削除</button>
            </div>
            <div class='table-container'>
                <table class='table is-striped is-hoverable is-fullwidth'>
                    <thead>
                        <tr>
                            <th class='selectbox'>選択</th>
                            <th class='name'>お名前</th>
                            <th class='email'>メールアドレス</th>
                            <th class='address'>住所</th>
                            <th class='login-id'>ログインID</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for='parent in parents' :key='parent.id'>
                            <td><input type='checkbox' class='checkbox' :value='parent.id' v-model='selectParents'></td>
                            <td>{{ parent.name }}</td>
                            <td>{{ parent.email }}</td>
                            <td>{{ parent.address }}</td>
                            <td>{{ parent.login_id }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Parent',
    components: {
    },
    props: ['schoolMap', 'selectSchoolId'],
    data () {
        return {
            parents: [],
            selectParents: []
        }
    },
    computed: {
    },
    watch: {
        selectSchoolId () {
            this.displayParent()
        }
    },
    mounted () {
        this.displayParent()
    },
    methods: {
        buyHistry () {

        },
        deleteParent () {

        },
        displayParent () {
            const self = this
            const params = self.$parent.requestParams

            self.axios.post(`${process.env.API_URL}/photographer/parent${params}`).then((res) => {
                console.log(res)
                self.parents = res.data.parents
            }).catch((e) => {
                self.$root.$emit('notification', 'is-danger', 'サーバーエラーが発生しました')
            })
        }
    }
}
</script>

<style scoped>

.tabs {
    width: calc(100vw - 200px);
}
.content {
    padding: 25px;
    margin: auto;
    min-width: 880px;
}

.buttons {
    margin: 0;
}

.buttons > button {
    height: 35px;
}

.quantity, .amount, .status, address, .selectbox {
    min-width: 60px;
}

.size, .created_at {
    min-width: 90px;
}

.name, .delivery, .payment {
    min-width: 120px;
}

.email {
    min-width: 210px;
}

th {
    max-width: 300px;
}

.status {
    min-width: 80px;
}

.checkbox {
    width: 20px;
    height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/photographer/pages/Parent.vue